export class FlowLoadingError extends Error {
  constructor(message, flowId = 'default') {
    super(message);
    this.name = `FlowLoadingError::${flowId}`;
  }
}
